import { Button, message, Modal, Spin, Tooltip } from "antd";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import metaLogo from '../assets/adsLogos/meta.png'
import { adsSendLeads } from "../lib/adsSendLeads";
import { adsGetUserConnections } from "../lib/adsGetUserConnections";
import { FaCheck } from "react-icons/fa";
import { BiSolidError } from "react-icons/bi";
import { usePostHog } from "posthog-js/react";
interface AdsContext {
  selectedAds: string | undefined;
  setSelectedAds: (value: string) => void;
  sendToAdsButton: (modal: boolean, record: object) => JSX.Element | null;
  options: object[];
  connections: object[];
  setUpdateConnections: (value: number) => void
  setSelectedListAds: (value: object)=> void
}

interface AdsOption{
  label: string,
  value: string,
  plataform: string,
  account: { id: string, name: string },
  audience: { id: string, name: string },
}

interface Connection{
  con_token: string,
  account_audience: { id: string, name: string, description: string },
  account_name: { id: string, name: string },
  con_date: string,
  con_name: string,
  plataform_name: string,
  status: boolean
}

const AdsContext = createContext({} as AdsContext);

export const AdsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const [connections, setConnections] = useState<Connection[]>([])
    const [options, setOptions] = useState<AdsOption[]>([])
    const [updateConnections, setUpdateConnections] = useState<number>(Math.random())
    const [selectedList, setSelectedListAds] = useState<object | undefined> (undefined)
    const [loadingAds, setLoadingAds] = useState<boolean>(false)
    const [sendingRecord, setSendingRecord] = useState<object[]>([])
    const [successfulysentLeads, setSucessfulySentLeads] = useState<object[]>([])
    const [failedToSendLeads, setFailedToSendLeads] = useState<object[]>([])  
    const posthog = usePostHog();

    useEffect(()=>{
      
      adsGetUserConnections().then(connections=>{
        setConnections(connections.body);
      })
    },[updateConnections])

    useEffect(() => { 
      if(!connections) return
      const filteredOptions = connections
        .filter((connection) => connection.status)
        .map((connection) => ({
          label: connection.con_name,
          value: connection.con_name,
          plataform: connection.plataform_name,
          account: connection.account_name,
          audience: connection.account_audience,
        }));   
      setOptions(filteredOptions);
    }, [connections]);
    

  const [selectedAds, setSelectedAds] = useState<string | undefined>(undefined);
  const adsLogos={'meta_ads':metaLogo}


  const RenderSendToAdsIcon: React.FC<{ modal: boolean, listName: string, record: object }> = ({ modal, listName,record }) => {
    const [modalVisibility, setModalVisibility] = useState<boolean>(false);
    const selectedOption = options.filter((option)=>(option.value === selectedAds))[0]
    const sendToAds = ()=>{
      setLoadingAds(true)
      setSendingRecord([...sendingRecord,record])
      const activeConnection = connections.filter(connection =>(connection.con_name === selectedOption.label))[0]
      
      adsSendLeads( selectedList ? selectedList.path :  localStorage.getItem('leadPath'), activeConnection.account_audience, activeConnection.con_token).then(response=>{
        if (response.statusCode === 200 && response.body.num_invalid_entries == 0){
           if(record.cnpj_completo){
            message.success('Lead enviado com sucesso')
          }
          else{
            message.success('Lista enviada com sucesso')
          }
          setSucessfulySentLeads([...successfulysentLeads,record])
        } else {
          if (response.statusCode === 400) {
            message.error(response.body)
          } else {
            message.error("Erro no envio de leads")
          } 
          if (response.body && response.body.num_invalid_entries > 0) {
            message.error(`Houve ${response.body.num_invalid_entries} leads inválidos`)
          } 
          setFailedToSendLeads([...failedToSendLeads,record])
        }
        setLoadingAds(false)
        setSendingRecord(sendingRecord.filter(value=>(value !== record)))
      })
    }
    
    return (
      <div>
        <Tooltip title={selectedOption.plataform}>
          <div style={{display:'flex', flexDirection:'column',alignItems:'center'}}>
        {
          loadingAds && sendingRecord?.includes(record)?
          <Spin/>
          :
          <Button
            icon={<img src={adsLogos[selectedOption.plataform]} alt={selectedOption.plataform} style={{transform:'scale(0.6)'}} />}
                  onClick={() => {
                    posthog.capture('send_to_ads_clicked_botao');
                    if (modal) {
                      setModalVisibility(true);
                    } else {
                      sendToAds();
                    }}}
            type="link"
            style={{ padding: 0 }}
          />
        }  
        {
          successfulysentLeads.includes(record)?
            <FaCheck color="#249882"/>
          :
          failedToSendLeads.includes(record)?
          <BiSolidError color="#fe6556"/>
          :
          <></>
        }
        </div>
        </Tooltip>
        <Modal
          title="Confirmar Envio"
          open={modalVisibility}
          onCancel={() => {
            posthog.capture('send_to_ads_modal_cancel_botao');
            setModalVisibility(false);
          }}
          onOk={() => {
            posthog.capture('send_to_ads_modal_confirm_botao')
            sendToAds();
            setModalVisibility(false);
          }}
        >
          <p>Deseja enviar {listName} para {selectedAds}?</p>
          <div style={{fontSize:'small'}}>
          <br/><p>Detalhes da conexão:</p>
          <p>Plataforma: {selectedOption.plataform}</p>
          <p>Conta: {`${selectedOption.account.id} - ${selectedOption.account.name}`}</p>
          <p>Audiência: {`${selectedOption.audience.id} - ${selectedOption.audience.name}`}</p>
          </div>
        </Modal>
      </div>
    );
  };

  const sendToAdsButton = (modal: boolean, record: object) => {
    return selectedAds === undefined ? null : (

      <RenderSendToAdsIcon modal={modal} listName={selectedList ? selectedList.id : localStorage.getItem('leadId')}record = {record}/>
    );
  };

  return (
    <AdsContext.Provider value={{ selectedAds, setSelectedAds, sendToAdsButton, options, connections, setUpdateConnections, setSelectedListAds }}>
      {children}
    </AdsContext.Provider>
  );
};

export const useAds = () => {
  const context = useContext(AdsContext);
  return context;
};

